import { render, staticRenderFns } from "./SwitchBox.vue?vue&type=template&id=16a79f2e&scoped=true"
import script from "./SwitchBox.vue?vue&type=script&lang=js"
export * from "./SwitchBox.vue?vue&type=script&lang=js"
import style0 from "./SwitchBox.vue?vue&type=style&index=0&id=16a79f2e&prod&scoped=true&lang=css"
import style1 from "./SwitchBox.vue?vue&type=style&index=1&id=16a79f2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a79f2e",
  null
  
)

export default component.exports